/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-07-31 14:01:30
 * @LastEditTime: 2020-09-27 17:28:48
 * @Description: vuex根目录
 */
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import customer from './modules/customer'
import department from './modules/department'
import company from './modules/company'
import user from './modules/user'
import material from './modules/material'
import factory from './modules/factory'
import purchase from './modules/purchase'
import recipeSemi from './modules/recipeSemi'
import recipeSales from './modules/recipeSales'
import sales from './modules/sales'
import sacCompany from './modules/sacCompany'
import sac from './modules/sac'
import tankRental from './modules/tankRental'
import salesOrder from './modules/salesOrder'
import vehicle from './modules/vehicle'
import delivery from './modules/delivery'
import salesOrderComment from './modules/salesOrderComment'
import salesRecord from './modules/salesRecord'
import customerPurview from './modules/customerPurview'
import technicalService from './modules/technicalService'
import customerDevelop from './modules/customerDevelop'
import caclSalesCost from './modules/caclSalesCost'
import caclMLCost from './modules/caclMLCost'
import salesPriceRecord from './modules/salesPriceRecord'
import salesTransCostRecord from './modules/salesTransCostRecord'
import customerContact from './modules/customerContact'
import salesPromoFeeRecord from './modules/salesPromoFeeRecord'
import semiItem from './modules/semiItem'
import calcSemiCost from './modules/calcSemiCost'
import storageTank from './modules/storageTank'
import salesStat from './modules/salesStat'
import receiveIO from './modules/socketIo/receiveIO'
import bankAccount from './modules/bankAccount'
import task from './modules/task'
import receive from './modules/receive'
import comment from './modules/comment'
import payment from './modules/payment'
import supplier from './modules/supplier'
import entity from './modules/entity'
import outStore from './modules/outStore'
import bill from './modules/bill'
import customerAnalyze from './modules/pages/customerAnalyze'
import customerQZUpdateForm from './modules/customerQZUpdateForm'
import duizhangdan from './modules/duizhangdan'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    factory,
    sac,
    customer,
    delivery,
    vehicle,
    salesOrder,
    department,
    sacCompany,
    recipeSemi,
    material,
    company,
    user,
    purchase,
    sales,
    recipeSales,
    tankRental,
    salesOrderComment,
    salesRecord,
    customerPurview,
    technicalService,
    customerDevelop,
    caclSalesCost,
    caclMLCost,
    salesPriceRecord,
    salesTransCostRecord,
    customerContact,
    salesPromoFeeRecord,
    calcSemiCost,
    semiItem,
    storageTank,
    salesStat,
    receive,
    receiveIO,
    bankAccount,
    task,
    comment,
    payment,
    supplier,
    entity,
    outStore,
    bill,
    customerAnalyze,
    customerQZUpdateForm,
    duizhangdan
  },
})